import { createRoute } from '@tanstack/react-router'
import { authLayoutRoute } from 'src/layouts/routes'

import { NotFoundPage } from '..'

export const notFoundRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  component: () => <NotFoundPage />,
  path: '/not-found'
})
